import { render, staticRenderFns } from "./stationed-city.vue?vue&type=template&id=5cbfae15&"
import script from "./stationed-city.vue?vue&type=script&lang=js&"
export * from "./stationed-city.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports